import { ETenant } from '../../../../api-models/common/json_query';

export const TENANTS_MAP_VALUE_TO_LABEL = {
  [ETenant.Any]: 'любой',
  [ETenant.Family]: 'семья',
  [ETenant.Man]: 'мужчина',
  [ETenant.Woman]: 'женщина',
};
